import { SlideType } from '@pcp/core/interfaces';
import { IDisplaySlide } from '@pcp/core/interfaces';
import { v1 } from 'uuid';

export const createVideoSlide = (
    vimeoVideoId: number,
    autoClose?: boolean
): IDisplaySlide => ({
    id: 0,
    type: SlideType.video,
    moduleId: 0,
    versionId: 0,
    caption: '',
    imageVariants: {},
    imageResource: '',
    previewpicture: {
        thumb_n: '',
        thumb_h: '',
    },
    hideFavoriteButton: true,
    parentId: 0,
    showCaption: false,
    autoClose,
    // vimeoVideoId: 329387445, // for testing: use a fixed video id
    vimeoVideoId,
    guid: v1(),
    questionModuleType: null
});
